module.exports = __webpack_public_path__ + "img/h_header-1.bfe51341.png";